<template>
	<div style="margin-right:50px">
	  <div class="subTop">
	    <em>Expert Opinion</em>
	    <span>观点评论</span>
	    <router-link to="/guandian" class="more" @click.native="$track([['pagetype','首页-观点评论-更多-点击']])">更多</router-link>
	  </div>
	  <a @click="zhuanjiaList.data[0].id?jumppush('/detail/'+zhuanjiaList.data[0].id):''" class="top top1">
	    <img :src="zhuanjiaList.data?zhuanjiaList.images[zhuanjiaList.data[0].id]:''"/>
	    <p>{{zhuanjiaList.data?zhuanjiaList.data[0].title:''}}</p>
	  </a>
	  <ul class="newsWap newsWap1">
			<li v-for="(item,index) in zhuanjiaList.data" v-if="index>0&&index<5">
				<a @click="jumppush('/detail/'+item.id)" :title="item.title">{{item.title}}</a>
			</li>
	    <!-- <li><a href="##">数字技术创新驱动现代谷物业与先进制造业深度融合</a></li>
	    <li><a href="##">金双根院士：智能网联汽车是自动驾驶汽车发展阶段</a></li>
	    <li><a href="##">中国工程院院士高文：算力会像电力一样随时使用</a></li>
	    <li><a href="##">中国工程院院士邬贺铨：5G能力尚未真正体现</a></li> -->
	  </ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isloading:true,
				zhuanjiaList: [],
			}
		},
		created:function(){
			this.zhuanjiafnc();
		},
		computed: {
	
		},
		methods: {
			showLogin: function() {
				this.$emit('showLogin');
			},
			jumppush:function(to){
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			zhuanjiafnc: function() {
				let _this = this;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'szjj/searchArticles',
						responseType: 'json',
						params: {
							columnID: 'e7dc7b6ba2b2466793b8a9a02c62626a',
							// isTopArticle: '1',
							iPage:'1',
							pageSize:'5',
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						_this.zhuanjiaList = response.data.data.data;
						_this.isloading=false;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
		}
	}
</script>

<style>
</style>
